import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const maintenanceBanner: ThemeApp['appComponents']['maintenanceBanner'] = {
  banner: {
    color: themeUi.semantic.color.text.notice500
  },
  inMaintenanceIcon: {
    color: themeUi.semantic.color.text.notice500,
    fill: themeUi.semantic.color.icon.notice500,
    pathFill: themeUi.semantic.color.icon.notice500
  },
  scheduledMaintenanceIcon: {
    color: themeUi.semantic.color.text.notice500,
    fill: themeUi.semantic.color.icon.notice500,
    pathFill: themeUi.semantic.color.icon.notice500
  },
  failoverEventIcon: {
    color: themeUi.semantic.color.text.notice500,
    fill: themeUi.semantic.color.icon.notice500,
    pathFill: themeUi.semantic.color.icon.notice500
  }
};
